export const getRootPath = (currentPath: string) => {
  const zenithRootPath = "/zenith";

  return currentPath.includes(zenithRootPath) ? zenithRootPath : "/";
};
